import { SyntheticEvent } from 'react';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {
  DatePickerMode,
  DateTimeRange,
  FixedDateTimeRange,
  LastDateTimeRange,
  SinceDateTimeRange,
} from '../types';
import { FixedModeControls } from './FixedModeControls';
import { SinceModeControls } from './SinceModeControls';
import { LastModeControls } from './LastModeControls';
import { DateRange, TabContext, TabList, TabPanel } from '@mui/lab';
import { getDateTimeRange } from '../helpers';
import { Dayjs } from 'v2/core/date/date';

interface DateRangePickerModesProps {
  mode: DatePickerMode;
  dateRange: DateRange<Dayjs | null>;
  timeRange: DateTimeRange | null;
  onChangeTimeRange: (timeRange: DateTimeRange) => void;
  onChangeMode: (timeRange: DateTimeRange, mode: DatePickerMode) => void;
  shouldHideDisplayModes?: boolean;
}

export function DateRangePickerModes({
  mode,
  dateRange,
  timeRange,
  onChangeTimeRange,
  onChangeMode,
}: DateRangePickerModesProps) {
  const handleChangeMode = (
    _: SyntheticEvent,
    newDatePickerMode: DatePickerMode,
  ) => {
    const newTimeRange = getDateTimeRange(dateRange, newDatePickerMode);
    onChangeMode(newTimeRange, newDatePickerMode);
  };

  return (
    <Box>
      <TabContext value={mode}>
        <TabList onChange={handleChangeMode} centered>
          <Tab label="Last" value="last" />
          <Tab label="Since" value="since" />
          <Tab label="Between" value="absolute" />
        </TabList>
        <TabPanel value="last" sx={{ p: 1.5 }} data-testid="last-panel">
          <LastModeControls
            dateRange={dateRange}
            timeRange={timeRange as LastDateTimeRange}
            onChange={onChangeTimeRange}
          />
        </TabPanel>
        <TabPanel value="since" sx={{ p: 1.5 }} data-testid="since-panel">
          <SinceModeControls
            dateRange={dateRange}
            timeRange={timeRange as SinceDateTimeRange}
            onChange={onChangeTimeRange}
          />
        </TabPanel>
        <TabPanel value="absolute" sx={{ p: 1.5 }} data-testid="absolute-panel">
          <FixedModeControls
            dateRange={dateRange}
            timeRange={timeRange as FixedDateTimeRange}
            onChange={onChangeTimeRange}
          />
        </TabPanel>
      </TabContext>
    </Box>
  );
}
